<template>
  <div id="agree">
    <el-button size="medium" @click="exportPDF" type="danger" class="export"
      >导出</el-button
    >
    <div class="topic-title">自由职业者服务协议</div>
	<div class="clause-content">甲方：{{channel_name}}</div>
	<div class="clause-content margin">统一社会信用代码：{{channel_taxpayer}}</div>
	<div class="clause-content">乙方：{{fullname}}</div>
	<div class="clause-content">身份证号：{{id_number}}</div>
  <div class="tips-clause">提示条款: </div>
			<div class="tips">【审慎阅读】<span
					class="tips-key">为维护双方的合法权益，在点击同意或书面签署《自由职业者合作协议》（下称“本协议”）之前，双方应认真阅读本协议文本，充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。上述条款以粗体及下划线标识，双方应重点阅读。</span>
			</div>
			<div class="tips">
				【签约】<span
					class="tips-key">甲乙双方应当按照本协议的约定填写相应的主体/个人信息、阅读并同意本协议且完成全部申请或书面签署后，即表示双方均已充分阅读、理解并接受本协议的全部内容，并达成一致意见，此后任何一方均不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果任何一方不同意本协议或其中任何条款约定，请立即停止任何的电子或书面签署程序。</span>
			</div>
			<div class="tips">
				【非格式条款】<span class="tips-key">甲乙双方确认，本协议条款是经当事人充分沟通协商，达成合意后拟定的。</span>
			</div>
			<div class="tips">
				【合作关系】<span
					class="tips-key">您与我司通过本合同建立合作关系，适用《中华人民共和国民法典》以及其他民事法律，不适用《中华人民共和国劳动合同法》。</span>您理解并确认，在服务过程中产生任何意外、事故，包括：触犯国家法律法规、对他人产生人身伤害、自身受到意外伤害等，由您承担全部责任和损失。您理解并确认，您为本平台上服务商及企业提供服务的行为是您依托个人技能对外提供的个人经营服务行为。您自行承担服务过程中产生的成本，自行采购服务所需要的生产工具，自我学习提供服务所需要的技能，自行购买相应的保险保障（如需要）。应国家相关法规要求，国家公务人员、军人等不得在我平台注册。您确认，您对外从业行为符合相关国家规定。
			</div>
			<div class="tips">
				【外包服务订单】<span
					class="tips-key">您通过本互联网灵活用工平台承接的外包服务项目以电子订单的形式签约，您阅读并同意外包服务电子订单且完成签署后，即表示您已充分阅读、理解并接受订单的全部内容。</span>
			</div>
			<div class="tips">
				【注册信息】<span
					class="tips-key">您的注册信息（包括您的姓名、身份证号、银行卡号、联系地址、联系电话等信息），以您提供的信息为准。您承诺并保证您所提供的签约信息真实、准确，以免影响您和我司之间的合同效力。</span>
			</div>
			<div class="tips">
				【代扣代缴】<span
					class="tips-key">您/本人委托我司代理本合同交易项下的涉税事务。您了解并同意我司按照相关税收法律法规为服务费用所涉税款代扣代缴，如需办理汇算清缴的，请您依法办理纳税申报。</span>
			</div>
			<div class="clause">
				<div class="clause-title">第一条 服务工作内容</div>
				<div class="clause-content">
					(一)
					我司作为互联网灵活用工平台为您寻找、筛选、匹配合适的外包（包括转包、分包等形式）业务，您可通过电子签约（包括但不限于电子合同、服务工单、任务发包等）的形式承接适合您自身能力与资质的外包业务。您应当按照外包业务服务对象的要求，按时完成规定的服务，达到要求的验收标准。
				</div>
				<div class="clause-content">(二)
					您承诺和保证，您依据本合同约定收取相关费用不违反任何法律法规和政策规定。若依据相关规定，您提供的相关服务和收费，应通过所在机构或以其他法律规定的方式进行，则您自行负责办理全部事宜，若因您的自身原因未办理前述事宜，则您应承担由此引起的全部法律后果，并赔偿由此给我司造成的全部经济损失。
				</div>
				<div class="clause-content">
					(三)
					您保证不会从事涉嫌违反法律及行政法规或其他不得使用我司服务的行为。相关国家机关介入调查时，您须应要求予以协助并如实反映情况，不得阻挠、拒绝调查。如因您从事涉嫌违法违规行为导致任何国家机关或授权机构对我司应向您支付的款项采取措施（包括但不限于查询、冻结、解冻），我司有权根据法律法规规定或相关国家机关或其授权机构的要求配合处理。如国家机关或其授权机构依法或依职权对相应款项进行扣划，您应予配合和接受，您在任何情况下均无权要求我司返还该笔款项。
				</div>
			</div>
			<div class="clause">
				<div class="clause-title">第二条 服务费用</div>
				<div class="clause-content">
					(一)
					我司将根据经业务发包方确认的项目服务人员服务标准及收费标准向您支付服务费用。由于您所提供的服务内容、服务质量、服务时长等情况的不同，该等服务费用金额可能会呈现浮动，您清楚并认可该等浮动为正常情况。我司以人民币形式向您支付服务费用，您应缴纳的与我司向您支付服务费用对应的劳务报酬个人所得税及其他相关税费，由我司负责代扣代缴。该代扣代缴约定，不应视为我司对您的生产经营所得负有申报、汇算清缴或者汇总申报之责任。
				</div>
				<div class="clause-content">(二)
					我司将通过银行账户向您支付业务外包费用。您应向我司提供以您本人实名注册的对应账户信息，以及相关必要的证件。若具体账户信息在指定的网络平台在线提供的，以您在线提供的信息为准。因您提供的银行账户错误而造成的损失由您自行承担。如您账号变更或发生不可用等情况时，应至少提前三个工作日书面通知我司。
				</div>
			</div>
			<div class="clause">
				<div class="clause-title">第三条 权利和义务</div>
				<div class="clause-content">
					(一)
					您应根据您承接的外包服务订单要求为发包方提供服务，并应当符合外包服务订单验收标准。若外包服务订单有变更的，一般应提前5个工作日通知并征求您的同意，在紧急情况之下可不受该时效限制。您拒绝变更后的外包服务订单的，已履行部分按照原订单结算规则按比例或公平原则结算。
				</div>
				<div class="clause-content">(二)
					您完成外包服务订单后，我司将按发包方的相关规定与发包方共同对您的服务成果进行验收。若您没有达到验收标准或已预期违约的，我司有权拒绝向您支付相应的外包费用并保留追究您违约责任的权利。</div>
				<div class="clause-content">
					(三) 我司应按本协议外包服务订单的约定及时向您支付费用。</div>
				<div class="clause-content">(四)
					您同意，您不可撤销地授权我司和发包方有权为提供前述费用结算服务的需要获取您的相关信息（包括但不限于个人身份信息、实名登记手机号码、银行账户相关信息等），并将您的相关信息提交第三方机构进行身份验证。若您提供任何错误、虚假、失效或不完整的资料，或者我司或发包方有合理的理由怀疑资料为错误、虚假、过期或不完整，我司或发包方有权暂停或终止向您提供部分或全部服务。您承诺并同意负担我司或发包方因此所产生的所有损失，包括但不限于直接损失、间接损失。若因国家法律法规、部门规章或监管机构的要求，我司或发包方需要您补充提供任何相关资料时，如您不能及时配合提供，我司或发包方有权暂停或终止向您提供部分或全部服务。
				</div>
				<div class="clause-content tips-key key">(五)
					您知晓通过本平台承揽外包业务获得的收入，应依法缴纳个人所得税，相关税费已包含在您应得的劳动报酬中，由我司以代扣代缴的形式帮您缴纳。您承接多项外包业务并取得收入的，根据税法规定需合并计算，因此可能导致您适用更高的个人所得税税率并按合并收入计算缴纳税款。
				</div>
				<div class="clause-content tips-key key">(六)
					尽管我司以代扣代缴的形式负责您的服务费用的申报工作，但您知晓并同意，因您汇算清缴过程中可能出现的补缴税款、滞纳金或其他税务责任，需要由您承担。我司不承担因汇算清缴产生的任何补缴责任或相关费用。
				</div>
				<div class="clause-content">(七)
					若因国家法律政策调整或应税务主管机关的要求需要您补缴税费的，我司将及时向您发出通知，发包方未能承担的，由您自行补缴或将需补缴的税款交于我司代为补缴。</div>
				<div class="clause-content">(八)
					您保证在本平台承接外包业务期间遵守法律法规，若因您涉及包括但不限于传销、赌博、洗钱、贩毒、非法集资等违法行为的，我司有权随时解除本合同，因此导致我司遭受损失的，包括但不限于我方银行账户被冻结、我方平台运营受到影响、我方被行政机关处罚或者产生其他损失（包括直接损失和间接损失），您需承担全部赔偿责任。
				</div>
				<div class="clause-content">(九)
					您应按时尽责地完成承包项目，并达到规定的质量标准，不得有侵犯他人知识产权、财产权、人身权、肖像权、隐私权、商业秘密或其他合法权益以及其他违反国家法律法规、国家政策或有悖于公序良俗的行为。如因上述事项造成国家或他人损失，造成的一切损失由您自行承担。
				</div>
				<div class="clause-content">(十)
					合作期间，您应在我司以及发包方许可范围内使用本合同有关的商业信息；合同期内以及合同终止后，您均有义务对双方合作的有关合同及合作过程中知悉的我司、发包方的相关信息予以保密，未经书面许可，您不得以任何方式向其他方披露、给予或转让该等保密信息。否则，因此导致我司及/或发包方或其关联公司的损失，由您负责赔偿。
				</div>
				<div class="clause-content">(十一) 除本合同项下事项外，您不能以我司及/或发包方的名义开展任何与完成约定的外包订单任务无关的业务或活动。</div>
				<div class="clause-content">(十二) 未经书面同意，您不得将本合同项下工作转包或分包给任何第三方，否则我司有权立即解除本合同。</div>
				<div class="clause-content">(十三)
					若相关服务通过发包方指定的网络平台提供，或者发包方指定的相关网络平台备案，发包方指定的网络平台可能将要求您签署、点击电子协议，您同意点击签署。您点击确认后该协议将对您产生法律效力。</div>
				<div class="clause-content">(十四) 您应当确认与发包方之间不存在人事劳动关系、股权关系、债权关系等本合同约定之服务内容之外的任何关系。</div>
			</div>
			<div class="clause">
				<div class="clause-title">第四条 保密</div>
				<div class="clause-content">(一)
					您在我司服务期间获取的文件、资料、表格等信息，包括但不限于有关技术资料、图纸、客户名单、合作情况、价格、营销等信息，无论是口头、书面的或是电子文件形式的，无论是客户的或是本公司的均属我司商业秘密。合同期限内及合同终止后均必须遵守保密约定，不得向外透露，并绝对禁止使用这些商业秘密为自己或他人谋取利益；违反本规定您须赔偿我司一切经济损失
				</div>
			</div>
			<div class="clause">
				<div class="clause-title">第五条 违约责任</div>
				<div class="clause-content">
					(一) 任何一方违反本协议条款约定的，守约方有权要求违约方及时改正；因此造成守约方损失的，守约方有权要求违约方赔偿。</div>
				<div class="clause-content">
					(二) 如您未按本协议约定或外包服务订单履行义务，我司有权终止本协议，同时将停止支付任何费用，您还应赔偿因违约而给我司或发包方造成的全部损失（包括但不限于我司或发包方因此承担的违约金、赔偿金、罚款、诉讼费、律师费、保全费及执行费的全部费用及丧失的商业机会所能带来的预计商业收益，合称“全部损失”）。
				</div>
				<div class="clause-content">
					(三) 因不可抗力造成损失的，双方均不承担赔偿责任，但发生不可抗力的一方应及时将有关情况通知另一方，并尽最大努力进行补救；本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾和风暴等以及社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等。
				</div>
			</div>
			<div class="clause">
				<div class="clause-title six">第六条 涉税事务委托授权</div>
				<div class="clause-content">
					(一)
					您本人委托我司代理本合同交易项下的涉税事务，包括但不限于办理涉税登记、代开发票、申报缴税等。
				</div>
				<div class="clause-content">(二) 您了解并同意我司按照相关税收法律法规为服务费用所涉税款代扣代缴，如需办理汇算清缴的，请您依法办理纳税申报。</div>
				<div class="clause-content">
					(三) 您本人确认我司根据本合同授权提交的相关申报资料和信息是真实、完整、准确和符合有关法律法规的。</div>
				<div class="clause-content">(四) 您本人同意并授权我司获取您的相关信息（包括但不限于个人身份信息、实名登记手机号码、银行账户相关信息等），并将您的前述个人信息提供给第三方认证机构用于生成您的数字证书，认证机构有权对您的信息进行核实、验证。若您提供的信息错误或者遗漏导致数字证书无法生成或者数字证书存在效力瑕疵的，您应及时更正或者补充相关信息。
				</div>
				<div class="clause-content">(五) 您本人确认与我司发包方不存在法律上和事实上的人事劳动关系，不属于发包方人事管理权限范围内的个人，也并非其股东。
				</div>
			</div>
			<div class="clause">
				<div class="clause-title">第七条 争议解决</div>
				<div class="clause-content">本协议的订立、执行和解释及争议的解决均应适用中国法律。凡因本协议引起的或与本协议有关的任何争议，双方应友好协商解决。如不能协商解决，双方均同意提请杭州仲裁委员会解决。双方同意以在平台存管的相关电子证据作为仲裁庭认定事实的依据，并认可平台就证据存管出具的相关证明文件。仲裁裁决是终局的，对双方均有约束力。双方清楚了解本条款的含义，并对此无异议。</div>
			</div>
			<div class="clause">
				<div class="clause-title">第八条 其他</div>
				<div class="clause-content">
					(一) 您确认，您注册信息中的地址为书面文件的送达地址，如您提供的地址不准确或地址变更后未及时告知我司致使文件无法送达的，则文件退回之日视为文件送达之日。</div>
				<div class="clause-content">(二) 本协议自甲方盖章您签字捺印后生效。若您以电子方式签署本协议，则本协议在您点击同意后立即生效，无需甲方另行签署。</div>
				<div class="clause-content">
					(三) 您通过本平台签署的外包服务订单属于本协议的附件，附件与主合同具有同等法律效力。</div>
			</div>
    <div class="clause">
      <div class="clause-content">（以下无正文）</div>
      <div class="both-sides">
        <div class="party-a">
          <img crossorigin="anonymous" v-if="seal_url" class="zhangImg" :src="seal_url" />
          <img crossorigin="anonymous" v-else-if="setId == '15799781160066'" class="zhangImg" src="https://img.51xinlong.com/xlwebsite/static/images/default/zhang.png" />
          <img crossorigin="anonymous" v-else-if="setId == '15199431830070' || setId == '15458925980082'" class="zhangImg" src="https://img.51xinlong.com/xlwebsite/static/images/default/zhang_baogu.png?any_string_is_ok2" />
          <img crossorigin="anonymous" v-else-if="setId == '15764028720071' || setId == '2088310322281512'" class="zhangImg" src="https://img.51xinlong.com/xlwebsite/static/images/default/zhang_xinyonggong.png?any_string_is_ok2" />
          <div>
            甲方：（盖章）
			<!-- <span>{{ this.channel_name }}</span> -->
          </div>
          <div>
            签署日期：<span>{{ this.created_at }}</span>
          </div>
        </div>
        <div class="party-b">
          <div class="bb-wrapper">
            <div>乙方：</div>
            <!-- <img id="autograph" src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png"
            data-imgUrl="http://fastmarket.oss-cn-shenzhen.aliyuncs.com/oss/static/other/1/images/baseMap_index.jpg"/> -->
			
            <img
              id="autograph"
              :src="this.sign_url"
              v-if="this.sign_url"
              :data-imgUrl="this.sign_url"
            />
            <!-- {{ this.sign_url ? "" : this.fullname }} -->
			（签字捺印或点击同意）
          </div>
          <div>
            <!-- 身份证号码：<span>{{ this.id_number }}</span> -->
          </div>
          <div>
            签署日期：<span>{{ this.created_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { xiaoke_setId } from "./setIdList.js";
export default {
  name: "ExportPdf",
  data() {
    return {
      agreeList: [
        {
          content: `【审慎阅读】为维护双方的合法权益，在点击同意或书面签署《自由职业者服务协议》（下称“本协议”）之前，双方应认真阅读本协议文本，充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。上述条款以粗体及下划线标识，双方应重点阅读。`,
        },
        {
          content: `【签约】甲乙双方应当按照本协议的约定填写相应的主体/个人信息、阅读并同意本协议且完成全部申请或书面签署后，即表示双方均已充分阅读、理解并接受本协议的全部内容，并达成一致意见，此后任何一方均不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果任何一方不同意本协议或其中任何条款约定，请立即停止任何的电子或书面签署程序。`,
        },
        {
          content: `【非格式条款】甲乙双方确认，本协议条款是经当事人充分沟通协商，达成合意后拟定的。`,
        },
		{
          content: `【服务关系】甲乙双方通过本协议建立服务关系，甲方是服务提供方，乙方是服务接受方，适用《民法典》和其他民事法律。`,
		}
      ],
      channel_name: "",
      company_name: "",
      created_at: "",
      sign_url: "",
      fullname: "",
      id_number: "",
      channel_taxpayer:"",
      setId:'',
      id:'',
      seal_url:'',
      category_name:'佣金结算、纳税申报'
    };
  },
  created() {
   this.getsignInfoById()
   this.getCustomerInfo()
    //设置跳转后滚动条默认为0
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
	const settlement_id = localStorage.getItem('settlementId')?localStorage.getItem('settlementId'):''
	let setId = settlement_id.replace(/"/g,'')
	this.setId = setId.toString()
    if(xiaoke_setId.includes(this.setId)){
      this.category_name = "任务领取、任务结算"
    }
  },
  methods: {
    //获取支持批量人才状态
    async getsignInfoById() {
      let args = {
        id: this.$route.query.id,
      };
      let data = await this.$api.getsignInfoById(args);
      if (data && data.status===1) {
        this.seal_url = data.seal_url;
      }
    },
    //获取基本信息
    async getCustomerInfo() {
      let args = {
        id: this.$route.query.id,
      };
      let info = await this.$api.getCustomerInfo(args.id);
      let {
            channel_name,
            company_name,
            created_at,
            sign_url,
            fullname,
            id_number,
            sign_type
        } = info

        this.company_name = company_name
        this.channel_name = channel_name
        this.created_at = created_at.split(" ")[0]
        this.sign_url = sign_url
        this.fullname = fullname
        this.id_number = id_number
        this.sign_type = sign_type

        if (sign_url && sign_type == "esign") {
            window.open('sign_url')
        }
    },
    exportPDF() {
      const title = "自由职业者协议";
      this.getPdf(title);
    },
    getPdf(title) {
      const opts = {
        scale: 2,
        dpi: window.devicePixelRatio * 4,
        useCORS: true,
        allowTaint: true, //允许加载跨域的图片
        tainttest: true, //检测每张图片都已经加载完成
        logging: false, //日志开关，发布的时候记得改成false
      };
      var canvas = document.createElement("canvas"),
        // url = `https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png`,
        url = this.sign_url,
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous"; // 重点！设置image对象可跨域请求
      img.src = url + "?timeStamp=" + new Date().getTime(); //解决缓存引起访问失败需要添加时间戳。。。。。问题的关键点
      if (url) {
        img.onload = function () {
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          // 将canvas的透明背景设置成白色
          var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          for (var i = 0; i < imageData.data.length; i += 4) {
            // 当该像素是透明的，则设置成白色
            if (imageData.data[i + 3] == 0) {
              imageData.data[i] = 255;
              imageData.data[i + 1] = 255;
              imageData.data[i + 2] = 255;
              imageData.data[i + 3] = 255;
            }
          }
          ctx.putImageData(imageData, 0, 0);
          var dataURL = canvas.toDataURL("image/jpeg");
          document.getElementById("autograph").setAttribute("src", dataURL);
          html2Canvas(document.getElementById("agree"), opts).then(function (
            canvas
          ) {
            console.log(canvas, "canvasa");
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            let pageHeight = (contentWidth / 592.28) * 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            let imgWidth = 595.28;
            let imgHeight = (592.28 / contentWidth) * contentHeight;
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            let PDF = new JsPDF("", "pt", "a4");
            if (leftHeight < pageHeight) {
              PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
            } else {
              while (leftHeight > 0) {
                PDF.addImage(
                  pageData,
                  "JPEG",
                  0,
                  position,
                  imgWidth,
                  imgHeight
                );
                leftHeight -= pageHeight;
                position -= 841.89;
                if (leftHeight > 0) {
                  PDF.addPage();
                }
              }
            }
            // var blob = PDF.output("blob");
            // window.open(URL.createObjectURL(blob));
            PDF.save(title + ".pdf");
          });
        };
      } else {
        html2Canvas(document.getElementById("agree"), opts).then(function (
          canvas
        ) {
          console.log(canvas, "canvasb");
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          // var blob = PDF.output("blob");
          // window.open(URL.createObjectURL(blob));
          PDF.save(title + ".pdf");
        });
      }
    },
  },
};
</script>
<style scoped lang="stylus">
.margin{
	margin-bottom: 10px;
}
.export {
  position: absolute;
  top: 20px;
  right: 40px;
}

#agree {
  color: #000;
  width: 596px;
  margin: 0 auto;
  padding: 0 60px;
  background: #fff;
}

.topic-title {
  display: block;
  text-align: center;
  padding: 20px 0;
  font-weight: bolder;
  font-size: 18pt;
}

.tips-clause {
  padding: 10px 0;
  font-weight: bolder;
  font-size: 9pt;
  text-indent: 2em;
}

.tips {
  // padding: 10px 0
  font-size: 9pt;
  font-weight: bolder;
  line-height: 20px;
  text-indent: 2em;
}

.tips-key {
  text-decoration: underline;
}

.terms {
  // padding-top: 20px
  // padding-bottom: 10px
  font-size: 9pt;
  line-height: 20px;
  text-indent: 2em;
}

.clause {
  padding: 10px 0;
}

.clause-title {
  margin-top: 15px;
  font-weight: bolder;
  font-size: 9pt;
  color: #000;
  text-indent: 2em;
}

.clause-content, .clause-content-content {
  // padding: 10px 0
  font-size: 9pt;
  line-height: 20px;
  text-indent: 2em;
}

.clause-content-content {
  margin-left: 20px;
}

.enclosure {
  text-align: center;
  font-weight: bolder;
  margin: 50px 0;
  font-size: 9pt;
}

.sign-company {
  margin-top: 30px;
  padding: 20px 0;
}

.key {
  font-weight: bolder;
  text-decoration: underline;
}

.close {
  margin-bottom: 30px;
}

.btn-row {
  margin-top: 10px;
  padding: 0 10px;
}

.both-sides {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 9pt;
  margin-top: 55px;
}

.party-a {
  line-height: 100px;
  margin-top: -35px;
  width: 100%;
  text-indent: 2em;
  position:relative;
}

.zhangImg{
	position:absolute;
	left:0px;
	top:0px;
	width:140px;
}

.party-b {
  line-height: 100px;
  margin-top: -35px;
  width: 100%;
}

.bb-wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
}

#autograph {
  width: 100px;
  height: 75px;
  position: absolute;
  top: 62px;
  left:40px;
}

.third {
  margin-top: 200px;
}

.six {
  margin-top: 200px;
}
</style>


